import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'
import {
  SearchApi,
  SearchRequestType,
  TSearchParams,
} from 'legacy/lut/classes/services/api/SearchApi'
import { history } from 'legacy/lut/helpers/route'

import { IForm } from 'core-components/classes/models/IForm'
import { IUser } from 'core-components/sitebuilder/models/IUser'
import GoogleAnalyticsService from 'core/analytics/GoogleAnalyticsService'
import { MarketApi } from 'core/classes/services/api/MarketApi'
import { CrudStore } from 'core/types/crudStore'
import Logger from 'core/utils/Logger'

interface ISearchPartnerParams {
  requestData: TSearchParams
  user: IUser
}

export const searchPartner = async ({ requestData, user }: ISearchPartnerParams) => {
  const terms: string[] = Object.values(requestData).filter((el) => !!el)

  try {
    GoogleAnalyticsService.trackSearch(history.location.pathname, terms, ['Partner Search'])
  } catch (error) {
    Logger.error('Error tracking search in Google Analytics:', error)
  }

  const api = new SearchApi(user)

  const partnerFilter = api.createAdvancedFilter(requestData, SearchRequestType.Partner)
  const contactFilter = api.createAdvancedFilter(requestData, SearchRequestType.Contact)

  const region = MarketApi.getRegion(user.geoMarket).Region

  if (region) {
    partnerFilter.filters.push({
      field: 'Region',
      operator: 'eq',
      value: region,
    })
    contactFilter.filters.push({
      field: 'Region',
      operator: 'eq',
      value: region,
    })
  }

  // builtin in ws
  if (requestData.IsDis === '1') {
    partnerFilter.filters.push({
      field: 'IsDis',
      operator: 'eq',
      value: '1',
    })
  }

  // never used
  if (requestData.IsPFPartner === '1') {
    partnerFilter.filters.push({
      field: 'IsPFPartner',
      operator: 'eq',
      value: '1',
    })
  }

  // builtin in ws
  if (requestData.IsAmpRet === '1') {
    partnerFilter.filters.push({
      field: 'IsAmpRet',
      operator: 'eq',
      value: '1',
    })
    contactFilter.filters.push({
      field: 'IsAmpRet',
      operator: 'eq',
      value: '1',
    })
  }

  if (requestData.IsRet === '1') {
    partnerFilter.filters.push({
      field: 'IsRet',
      operator: 'eq',
      value: '1',
    })
    contactFilter.filters.push({
      field: 'IsRet',
      operator: 'eq',
      value: '1',
    })
  }

  // builtin in ws
  if (requestData.IsAmpComm === '1') {
    partnerFilter.filters.push({
      field: 'IsAmpComm',
      operator: 'eq',
      value: '1',
    })
    contactFilter.filters.push({
      field: 'IsAmpComm',
      operator: 'eq',
      value: '1',
    })
  }

  if (requestData.IsComm === '1') {
    partnerFilter.filters.push({
      field: 'IsComm',
      operator: 'eq',
      value: '1',
    })
    contactFilter.filters.push({
      field: 'IsComm',
      operator: 'eq',
      value: '1',
    })
  }

  const partnerCrud = CrudStore.get(CrudStoreItem.SearchAPIPartner, 'search-partner-list')
  const contactCrud = CrudStore.get(CrudStoreItem.SearchAPIContact, 'search-contact-list')

  partnerCrud.setFilter(partnerFilter)
  partnerCrud.setPaging({
    page: 0,
    pageSize: 10,
  })
  contactCrud.setFilter(contactFilter)
  contactCrud.setPaging({
    page: 0,
    pageSize: 10,
  })
}
